<template>
    <body style="direction: rtl; text-align: right; padding: 70px 0px 0 0px;">
        <div class="container mb-4">
            <Header />
            <div v-if="isLoading && (!freelancers.length || !posts.length)" class="loading-overlay">
                <div class="spinner"></div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-md-2"></div>
                    <div v-if="freelancers.length === 0" class="text-center">
                        <p>لا يوجد مستقلون ضمن هذه الفئة.</p>
                    </div>
                    <div v-else class="cards-wrapper">
                        <p class="fw-bold mb-1" style="color: #296080;font-size: large;">أفضل المستقلين</p>
                        <div class="cards-container">
                            <FreelancerCard v-for="freelancer in freelancers" :key="freelancer.profiles_id"
                            :freelancer="freelancer" @update-save-status="updateSaveStatus" />
                        </div>
                    </div>
                </div>

                <div v-if="posts.length === 0" class="text-center">
                    <p>لا توجد منشورات ضمن هذه الفئة.</p>
                </div>
                <div v-else class="d-flex justify-content-center mt-2">
                    <div class="col-lg-6">
                        <p class="fw-bold" style="color: #296080;font-size: large;">المنشورات</p>
                        <div v-for="post in posts" :key="post.posts_id">
                            <PostCard :post="post" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </body>
</template>

<script>
import axios from "axios";
import Header from "../../components/header.vue";
import Footer from "../../components/footer.vue";
import PostCard from "../../components/PostCard.vue";
import FreelancerCard from "../../components/FreelancerCard.vue";

export default {
    name: "ProfessionsDetailsPage",
    components: {
        Header,
        Footer,
        PostCard,
        FreelancerCard,
    },
    data() {
        return {
            categoryId: this.$route.params.id,
            freelancers: [],
            posts: [],
            isLoading: false, // تعديل لجعل اللودينغ أقل ظهوراً عند العودة
        };
    },
    methods: {
        fetchFreelancers() {
            if (this.freelancers.length) return; // إذا كانت البيانات موجودة لا يتم الاستدعاء مرة أخرى

            this.isLoading = true;
            const formData = new FormData();
            formData.append("categoryId", this.categoryId);
            formData.append("limit", 10);

            axios
                .post("https://zadcodeonline.com/ahmad/etqan/backEnd/categories/view_freelancer.php", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.isLoading = false;
                    if (response.data.status === "success") {
                        this.freelancers = response.data.data;
                    }
                })
                .catch((error) => {
                    this.isLoading = false;
                    console.error("Error fetching freelancers:", error);
                });
        },
        fetchPosts() {
            if (this.posts.length) return; // إذا كانت البيانات موجودة لا يتم الاستدعاء مرة أخرى

            this.isLoading = true;
            const formData = new FormData();
            formData.append("categoryId", this.categoryId);
            formData.append("limit", 10);

            axios
                .post("https://zadcodeonline.com/ahmad/etqan/backEnd/categories/view_post.php", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.isLoading = false;
                    if (response.data.status === "success") {
                        this.posts = response.data.data;
                    }
                })
                .catch((error) => {
                    this.isLoading = false;
                    console.error("Error fetching posts:", error);
                });
        },
    },
    mounted() {
        this.fetchFreelancers();
        this.fetchPosts();
    },
};
</script>


<style scoped>
.cards-wrapper {
    position: relative;
    overflow-x: auto;
    white-space: nowrap;
    padding-bottom: 10px
}

.cards-container {
    display: inline-flex;
    gap: 10px;
    padding: 10px;
}

.card {
    flex: 0 0 auto;
    border-radius: 15px;
    background-color: #faf9f8;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
}

.card:hover {
    transform: scale(1.05);
}

.cards-wrapper::-webkit-scrollbar {
    height: 8px;
}

.cards-wrapper::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.cards-wrapper::-webkit-scrollbar-thumb:hover {
    background: #555;
}


body {
    background-color: #f5f5f5;
    padding-top: 55px;
}

.card-link {
    text-decoration: none;
    color: inherit;
    transition: transform 0.2s ease;
}

.card-link:hover {
    transform: scale(1.02);
}


@media (max-width: 768px) {
    .filter-container {
        order: -1;
    }

    .cards-container {
        order: 0;
    }
}

.footerCard {
    padding: 6px 0 5px 15px !important;
}

.card-body {
    padding: 0px 10px 0 10px !important;
}


.circle-btn {
    width: 50px;
    height: 50px;
    border: none;
    border-radius: 50%;
    color: #296080;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.circle-btn:hover {
    background-color: #f1995d;
    transform: scale(1.1);
}

.circle-btn i {
    font-size: 18px;
}


@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;

    background-color: #faf9f8;
    border-radius: 25px !important;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.card-header {
    padding: 0.7rem !important;
    background-color: #faf9f8;
    border-radius: 15px;
}


.post-images-container {
    margin-top: 15px;
}

.single-image img {
    width: 100%;
    height: auto;
}

.two-images img {
    width: 49%;
    height: auto;
}

.three-or-more-images {
    display: flex;
    flex-wrap: wrap;
}

.three-or-more-images .main-image img {
    width: 100%;
    height: 200px;
    object-fit: cover;
}

.three-or-more-images .other-images img {
    width: 49%;
    height: 100px;
    object-fit: cover;
    position: relative;
}

.three-or-more-images .overlay {
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    width: 49%;
    z-index: 1;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #296080;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.spinner {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #3498db;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}


@media (max-width: 992px) {
    .navbar-light .navbar-nav .nav-link[data-v-5e4cad4c] {
        color: #296080;
    }

    .navbar>.container,
    .navbar>.container-fluid,
    .navbar>.container-sm,
    .navbar>.container-md,
    .navbar>.container-lg,
    .navbar>.container-xl,
    .navbar>.container-xxl {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: inherit;
        flex-wrap: inherit;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        flex-direction: row-reverse;
    }
}
</style>
